import { useStore } from "../index";

export const useProjectMember = () => useStore(({ projectMember }) => projectMember);
